var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumping_word"},_vm._l((_vm.word),function(letter){return _c('h1',{key:letter + Math.random() * 101,staticClass:"letter"},[_vm._v(" "+_vm._s(letter)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }